import React, { useState } from 'react'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import UserLogo from '../../../../images/rewampimages/user.png'
import DocLogo from '../../../../images/rewampimages/document.png'
import EditLogo from '../../../../images/rewampimages/edit.png'
import Loader from '../../../presentationals/Loader/Loader.component'
import Popup from '../../../presentationals/Popup/Popup.component'

export default function InsuranceDetails({ handleType, detailData }) {
    const [tab, setTab] = useState("basic");
    const [loader, setLoader] = useState(false)
    const [popup, setPopup] = useState({ show: false, popupStatus: '' })
    const [reportView, setReportView] = useState({ show: false, url: "" })

    const closePopup = () => {
        setPopup({ show: false, popupStatus: '' })
    }

    const removePopup = () => {
        setTimeout(() => {
            closePopup()
        }, 5000)
    }

    const handleReport = (type, link) => {
        setReportView({ show: type, url: link })
    }

    return (
        <>
            {
                loader ? <Loader /> : ""
            }
            {
                popup?.show ? <Popup popupStatus={popup?.popupStatus} closePopup={closePopup} /> : ""
            }
            <div className='communitySection' style={{ marginTop: '20px' }}>
                <div className="container-fluid">
                    <ArrowBackIcon style={{ marginBottom: '15px', cursor: 'pointer', fontSize: '24px', color: '#000' }} onClick={() => handleType("list", "")} />

                    <div className="row">
                        <div className='edit-profile-menu col-xs-12'>
                            <div className='btn-group-tab'>
                                <div>
                                    <button className={tab == "basic" ? "active" : ""} onClick={() => setTab("basic")}>Basic Details</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {
                    tab == "basic" ?

                        <div className="container-fluid details-new ">
                            <div className="row">
                                <div className="col-xs-12">
                                    <div className='details-body' style={{ boxShadow: 'grey 3px 3px 10px -8px', marginTop: '30px' }}>
                                        <div className="details-head">
                                            <div className="row">
                                                <div className="col-sm-9 col-xs-11">
                                                    <div style={{ marginTop: '6px' }}>
                                                        <img src={UserLogo} style={{ width: '20px' }} /> &nbsp;
                                                        <b style={{ marginTop: '14px' }}>Personal Information</b>
                                                    </div>
                                                </div>


                                            </div>
                                        </div>
                                        <div style={{ padding: '10px', background: "#fff", borderBottomLeftRadius: '12px', borderBottomRightRadius: '12px' }}>
                                            <div className="row" >
                                                <div className="col-sm-3 col-xs-12" style={{ marginTop: '10px' }}>
                                                    <label>CIF No.</label>
                                                    <p>{detailData?.cifNo || "-"}</p>
                                                </div>
                                                <div className="col-sm-3 col-xs-12" style={{ marginTop: '10px' }}>
                                                    <label>Customer Name</label>
                                                    <p>{detailData?.customerName || "-"}</p>
                                                </div>

                                                <div className="col-sm-3 col-xs-12" style={{ marginTop: '10px' }}>
                                                    <label>Mobile No.</label>
                                                    <p>{detailData?.phoneNo || "-"}</p>
                                                </div>
                                                <div className="col-sm-3 col-xs-12" style={{ marginTop: '10px' }}>
                                                    <label>Residence Address</label>
                                                    <p>{detailData?.residenceAddress || "-"}</p>
                                                </div>
                                            </div>
                                            <div className="row" >
                                                <div className="col-sm-3 col-xs-12" style={{ marginTop: '10px' }}>
                                                    <label>Area</label>
                                                    <p>{detailData?.area || "-"}</p>
                                                </div>
                                                <div className="col-sm-3 col-xs-12" style={{ marginTop: '10px' }}>
                                                    <label>Locality</label>
                                                    <p>{detailData?.locality || "-"}</p>
                                                </div>
                                                <div className="col-sm-3 col-xs-12" style={{ marginTop: '10px' }}>
                                                    <label>District</label>
                                                    <p>{detailData?.district || "-"}</p>
                                                </div>
                                                <div className="col-sm-3 col-xs-12" style={{ marginTop: '10px' }}>
                                                    <label>State</label>
                                                    <p>{detailData?.state || "-"}</p>
                                                </div>
                                            </div>
                                            <div className="row" >
                                                <div className="col-sm-3 col-xs-12" style={{ marginTop: '10px' }}>
                                                    <label>PinCode</label>
                                                    <p>{detailData?.pinCode || "-"}</p>
                                                </div>
                                                <div className="col-sm-3 col-xs-12" style={{ marginTop: '10px' }}>
                                                    <label>Dealer Name</label>
                                                    <p>{detailData?.dealerName || "-"}</p>
                                                </div>
                                                <div className="col-sm-3 col-xs-12" style={{ marginTop: '10px' }}>
                                                    <label>Agent Name</label>
                                                    <p>{detailData?.agentName || "-"}</p>
                                                </div>
                                                <div className="col-sm-3 col-xs-12" style={{ marginTop: '10px' }}>
                                                    <label>FI Agency</label>
                                                    <p>{detailData?.fiAgency || "-"}</p>
                                                </div>
                                            </div>
                                            <div className="row" >
                                                <div className="col-sm-3 col-xs-12" style={{ marginTop: '10px' }}>
                                                    <label>FI Status</label>
                                                    <p style={{ color: detailData?.fiStatus == "Positive" ? "green" : "red", fontWeight: '700' }}>{detailData?.fiStatus || "-"}</p>
                                                </div>
                                                <div className="col-sm-3 col-xs-12" style={{ marginTop: '10px' }}>
                                                    <label>Initiation Date</label>
                                                    <p>{detailData?.initiationDateTime || "N/A"}</p>
                                                </div>
                                                <div className="col-sm-3 col-xs-12" style={{ marginTop: '10px' }}>
                                                    <label>Completed Date</label>
                                                    <p>{detailData?.completedDateTime || "N/A"}</p>
                                                </div>
                                                <div className="col-sm-3 col-xs-12" style={{ marginTop: '10px' }}>
                                                    <label>Remarks</label>
                                                    <p>{detailData?.remarks || "-"}</p>
                                                </div>
                                            </div>
                                            <div className="row" >
                                                <div className="col-sm-3 col-xs-12" style={{ marginTop: '10px' }}>
                                                    <label>FI Report</label>
                                                    <p onClick={() => handleReport(true, detailData?.fiReportLink)}><i className='fa fa-eye'></i> &nbsp; View</p>
                                                </div>

                                            </div>



                                        </div>
                                    </div>
                                </div>

                            </div>


                        </div>
                        : ''
                }


                {
                    reportView?.show ?
                        <div className="background-blur">

                            <div className="popup-main small-popup container-fluid max-width-500px dbl-border " style={{ padding: '20px', borderRadius: '10px' }}>
                                <i onClick={() => handleReport(false,"")} style={{ float: "right", marginTop: '-18px', marginRight: '-17px', fontSize: '20px', color: 'red' }} className="fa fa-times-circle"></i>
                                <div className="row from-group">
                                    <div className="col-xs-12" style={{ padding: '10px' }}>
                                        <h4 className="text-center" style={{ marginBottom: '10px', marginTop: '10px' }}>FI Report</h4>
                                    </div>
                                </div>

                                <div>
                                    <iframe src={reportView?.url} width={"100%"} height={"400px"}/>
                                </div>
                               
                            </div>
                        </div>
                        : ""}
            </div>
        </>
    )
}
